import { Box, Chip, Dialog } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '../../shared/components/MUI/button/Button';
import { LOCAL_STORAGE_KEY_USER_EMAIL_CONFIRMED, useUserContext } from '../../shared/contexts';
import { feedback, userService } from '../../shared/services';

export const ConfirmEmail: React.FC = () => {
  const [message, setMessage] = useState<string>();

  const { email, token } = useParams<{ email: string, token: string }>();

  const navigate = useNavigate();
  const { setEmailConfirmed } = useUserContext();

  const { mutate, isLoading } = useMutation((params: { email: string, token: string }) =>
    userService.confirmEmail(params.email, params.token), {
    onSuccess: () => {
      localStorage.setItem(LOCAL_STORAGE_KEY_USER_EMAIL_CONFIRMED, JSON.stringify(true));
      setEmailConfirmed(true);
      feedback('E-mail confirmado!', 'success');
      navigate('/home');
    },
    onError: (error: Error) => {
      setMessage(error.message);
    },
  });

  useEffect(() => {
    email && token && mutate({ email, token });
  }, [email, token]);

  const hasError = message?.startsWith('Error');

  const chipColor = () => {
    if (!message) {
      return 'warning';
    }

    if (hasError) {
      return 'error';
    }

    return 'success';
  };

  return (
    <Dialog open>
      <Box
        width={400}
        height={500}
        padding={4}
        gap={2}
        display='flex'
        flexDirection='column'
        justifyContent='center'
        alignItems='center'
      >
        <Chip label={message ?? 'Carregando...'} color={chipColor()} />

        <Button
          label='Voltar para página inicial'
          disabled={!hasError}
          isLoading={isLoading}
          variant='contained'
          onClick={() => navigate('/home')}
        />
      </Box>
    </Dialog>
  );
};
